import React, { useState } from "react";
import Select from "../../UI/Select/Select";
import { Col, Form, Row } from "react-bootstrap";
import SecBTN from "../../UI/SecBTN";
import userService from "../../app/services/user.service";
import { useNavigate } from "react-router-dom";

const BulkQuestion = () => {
  const [questionType, setQuestionType] = useState("");
  const [language, setLanguage] = useState("");
  const [file, setFile] = useState(null);

  const navigate = useNavigate();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const uploadBulkQuestion = () => {
    if (!questionType || !language || !file) {
      alert("Please select all fields and upload a file.");
      return;
    }

    const formData = new FormData();
    formData.append("questionType", questionType);
    formData.append("language", language);
    formData.append("file", file);

    console.log("Form Data:", formData);
    const payload = {
      questionType: questionType,
      language: language
    };

    userService
      .bulkQuestionUpload(formData)
      .then((res) => {
        console.log("API success", res.result);
        alert("About section uploaded successfully!");

        navigate('/topicwiseQuestionHtml', { state: { responseData: res.result, language: language, module: "bulkques" } });
      })
      .catch((err) => {
        console.error("API error", err);
        alert("Failed to upload About section.");
      });
  };

  // Function to download sample template
  const downloadTemplate = () => {
    fetch(window.location.origin + "/files/temp3.xlsx")
      .then((response) => response.blob())
      .then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = fileURL;
        link.download = "temp3.xlsx";
        link.click();
      })
      .catch((error) => console.error("Download error:", error));
  };

  return (
    <Row>
      <Col lg={6} md={6} sm={12} className="mb-3">
        <Form.Group controlId="formQuestionType" className="mb-3">
          <Form.Label>Select Question Type:</Form.Label>
          <Select onChange={(e) => setQuestionType(e.target.value)}>
            <option value="">Select</option>
            <option value="numbering">Question Numbering</option>
            <option value="subjectwise">Subjectwise</option>
          </Select>
        </Form.Group>

        <Form.Group controlId="formLanguage" className="mb-3">
          <Form.Label>Select Language:</Form.Label>
          <Select onChange={(e) => setLanguage(e.target.value)}>
            <option value="">Select</option>
            <option value="english">English</option>
            <option value="hindi">Hindi</option>
            <option value="both">Both</option>
          </Select>
        </Form.Group>

        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Upload here:</Form.Label>
          <Form.Control type="file" onChange={handleFileChange} />
        </Form.Group>

        <SecBTN className="sec-btn1" onClick={uploadBulkQuestion}>
          Upload
        </SecBTN>
      </Col>

      <Col lg={6} md={6} sm={12}>
        <SecBTN className="sec-btn1" onClick={downloadTemplate}>
          <i className="fa fa-download"></i> Sample File
        </SecBTN>
      </Col>
    </Row>
  );
};

export default BulkQuestion;